import { Component } from '@angular/core';

@Component({
  selector: 'app-section-mapa',
  templateUrl: './section-mapa.component.html',
  styleUrls: ['./section-mapa.component.scss'],
})
export class SectionMapaComponent {}
